// extracted by mini-css-extract-plugin
export default {"auth":"auth_auth__K7BQK"};